import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stateAlert } from "../../Store/simulate/actions";

const AlertNotifications = () => {
  const dispatch = useDispatch();
  const { stateAlert: stateActive, alert } = useSelector(
    (state: any) => state.simulate.policy
  );

  return (
    <>
      {stateActive && (
        <div
          className={
            alert.type == "success"
              ? "box__alert is--boxTrue"
              : "box__alert is--boxFalse"
          }
        >
          <div className="grid__alert">
            <div
              className={
                alert.type == "success"
                  ? "alert-icon-succes"
                  : "alert-icon-danger"
              }
            ></div>
            <div className="alert-desciption">
              <p>{alert.title}</p>
              <p>{alert.message}</p>
            </div>
            <div
              className={
                alert.type == "success" ? "is-close-succes" : "is-close-danger"
              }
              onClick={() => dispatch(stateAlert(false))}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlertNotifications;
